namespace AgerLMS.LMS {
    export interface DiscountOrderedCoursesRow {
        Id?: number;
        DiscountId?: number;
        CourseId?: number;
        DiscountTitle?: string;
        DiscountDiscountType?: number;
        DiscountSource?: number;
        DiscountProductType?: number;
        DiscountGroups?: string;
        DiscountPercentage?: number;
        DiscountMaxAmount?: number;
        DiscountMinimumOrder?: number;
        DiscountUsableTimes?: number;
        DiscountCoupon?: string;
        DiscountExpiryDate?: string;
        DiscountOnlyFirst?: number[];
        DiscountInsertDate?: string;
        DiscountInsertUserId?: number;
        DiscountUpdateDate?: string;
        DiscountUpdateUserId?: number;
        DiscountIsActive?: number;
        CourseCourseName?: string;
        CourseCourseDescription?: string;
        CourseCategoryId?: number;
        CoursePrice?: number;
        CourseSalePrice?: number;
        CourseInsertDate?: string;
        CourseInsertUserId?: number;
        CourseUpdateDate?: string;
        CourseUpdateUserId?: number;
        CourseIsActive?: number;
        CourseSeoMetaDescription?: string;
        CourseThumbnail?: string;
        CourseCoverImage?: string;
        CourseDemoVideoSource?: number;
        CourseDemoVideo?: string;
        CourseDownloadable?: number[];
        CourseAccessPeriodDays?: number;
        CourseSeo?: string;
        CourseInstructorId?: number;
        CourseDuration?: number;
    }

    export namespace DiscountOrderedCoursesRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.DiscountOrderedCourses';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            DiscountId = "DiscountId",
            CourseId = "CourseId",
            DiscountTitle = "DiscountTitle",
            DiscountDiscountType = "DiscountDiscountType",
            DiscountSource = "DiscountSource",
            DiscountProductType = "DiscountProductType",
            DiscountGroups = "DiscountGroups",
            DiscountPercentage = "DiscountPercentage",
            DiscountMaxAmount = "DiscountMaxAmount",
            DiscountMinimumOrder = "DiscountMinimumOrder",
            DiscountUsableTimes = "DiscountUsableTimes",
            DiscountCoupon = "DiscountCoupon",
            DiscountExpiryDate = "DiscountExpiryDate",
            DiscountOnlyFirst = "DiscountOnlyFirst",
            DiscountInsertDate = "DiscountInsertDate",
            DiscountInsertUserId = "DiscountInsertUserId",
            DiscountUpdateDate = "DiscountUpdateDate",
            DiscountUpdateUserId = "DiscountUpdateUserId",
            DiscountIsActive = "DiscountIsActive",
            CourseCourseName = "CourseCourseName",
            CourseCourseDescription = "CourseCourseDescription",
            CourseCategoryId = "CourseCategoryId",
            CoursePrice = "CoursePrice",
            CourseSalePrice = "CourseSalePrice",
            CourseInsertDate = "CourseInsertDate",
            CourseInsertUserId = "CourseInsertUserId",
            CourseUpdateDate = "CourseUpdateDate",
            CourseUpdateUserId = "CourseUpdateUserId",
            CourseIsActive = "CourseIsActive",
            CourseSeoMetaDescription = "CourseSeoMetaDescription",
            CourseThumbnail = "CourseThumbnail",
            CourseCoverImage = "CourseCoverImage",
            CourseDemoVideoSource = "CourseDemoVideoSource",
            CourseDemoVideo = "CourseDemoVideo",
            CourseDownloadable = "CourseDownloadable",
            CourseAccessPeriodDays = "CourseAccessPeriodDays",
            CourseSeo = "CourseSeo",
            CourseInstructorId = "CourseInstructorId",
            CourseDuration = "CourseDuration"
        }
    }
}
